import { v4 as uuidv4 } from 'uuid';

export const generateUniqueId = () => {
    return uuidv4();
};

export const cloneAsObject = (obj) => {
    if (obj === null || !(obj instanceof Object)) {
        return obj;
    }
    var temp = (obj instanceof Array) ? [] : {};
    for (var key in obj) {
        temp[key] = cloneAsObject(obj[key]);
    }
    return temp;
};

export const getFirstAndLastUppercase = (str) => {
    if (str.length < 2) {
        return str.toUpperCase();
    }
    const firstLetter = str.charAt(0).toUpperCase();
    const lastLetter = str.charAt(str.length - 1).toUpperCase();
    return firstLetter + lastLetter;
};

export const handleRefresh = (e) => {
    var confirmationMessage = "\\o/";
    (e || window.event).returnValue = confirmationMessage;
    return confirmationMessage;
};
